import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const getPaymentModesFromCheckout = createAppAsyncThunk(
  'checkout/getPaymentModesFromCheckout',
  async (_, { getState, rejectWithValue, extra: { checkoutService } }) => {
    try {
      const storeId = getState().root.storeConf.storeId;
      return await checkoutService.getPaymentModesForStoreId({ storeId, isApplePayEnabled: false });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
